module.exports = __webpack_public_path__ + "static/media/justinHeadshot.d953ec09.jpg";